var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteWork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 564.66 564.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ed1b3e;}.cls-2{fill:#fff;stroke:#fff;stroke-miterlimit:10;stroke-width:50px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "objects"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 282.33,
    cy: 282.33,
    r: 282.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 273.3,
    y: 153.89,
    width: 18.07,
    height: 256.88,
    rx: 9.03,
    transform: "translate(-116.94 282.33) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 273.3,
    y: 153.89,
    width: 18.07,
    height: 256.88,
    rx: 9.03,
    transform: "translate(282.33 -116.94) rotate(45)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteWork);
export default __webpack_public_path__ + "static/media/delete_work.def8ed4e661c1603b70230fdc99ccc74.svg";
export { ForwardRef as ReactComponent };